<template>
  <div class="vx-col w-5/6 ml-auto mr-auto">
     <span>
      <b v-if="id!=null">Edit Distribution Channel</b>
      <b v-else>Create Distribution Channel</b>
    </span>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label class="vs-input--label">Customer Category</label>
      </div>
      <div class="vx-col w-full">
        <multiselect
            placeholder="Type to search"
            :options="customerCategory.options"
            v-model="customerCategory.selected"
            track-by="name"
            label="name"
            :max-height="125"
            :internal-search="false"
        >
        </multiselect>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <label class="vs-input--label">Active</label>
        <br />
        <vs-radio name="isActive" v-model=isActive vs-value=1>Active</vs-radio>&nbsp;&nbsp;&nbsp;
        <vs-radio name="isActive" v-model=isActive vs-value=0>Nonactive</vs-radio>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click="handleSubmit">Submit</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="danger" v-on:click="handleClose">Close</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: Number
    },
    url: {
      type: String
    }
  },
  data() {
    return this.initialState();
  },
  methods: {
    initialState() {
      return {
        data: {
          id: null,
          name: "",
          isActive: null
        },
        customerCategory: {
          options: [],
          selected: {}
        },
        isActive: null
      };
    },
    handleSubmit() {
      if (this.id) {
        this.putData();
      } else {
        this.postData();
      }
    },
    paramData() {
      return {
        customerCategoryId: this.customerCategory.selected.id,
        status: parseInt(this.isActive)
      };
    },
    getDataCustomerCategory() {
      this.$vs.loading();
      this.$http
          .get("/api/v1/master/customer-category", {
            params: {
              order: "name",
              sort: "asc",
            },
          })
          .then((resp) => {
            if (resp.status == "success") {
              this.customerCategory.options = resp.data.records;
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
            }
          });
    },
    postData() {
      this.$http
          .post(this.url, this.paramData())
          .then(resp => {
            this.$vs.loading.close();
            if (resp.code == 200) {
              this.handleClose();
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "Success",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle"
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle"
              });
            }
          })
          .catch(error => {
            this.$vs.loading.close();
            console.log(error);
          });
    },
    putData() {
      this.$http
          .put(this.url + "/" + this.id, this.paramData())
          .then(resp => {
            this.$vs.loading.close();
            if (resp.code == 200) {
              this.handleClose();
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "Success",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle"
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle"
              });
            }
          })
          .catch(error => {
            this.$vs.loading.close();
            console.log(error);
          });
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    getData() {
      this.$vs.loading();
      this.$http
          .get(this.url + "/" + this.id)
          .then(resp => {
            this.$vs.loading.close();
            console.log(resp.data)
            if (resp.code == 200) {
              this.data.id = resp.data.ID;
              this.customerCategory.selected = {
                id: resp.data.CustomerCategory.ID,
                name: resp.data.CustomerCategory.name,
              }
              console.log(this.customerCategory.selected);
              this.isActive = resp.data.Status
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle"
              });
            }
          })
          .catch(error => {
            this.$vs.loading.close();
            console.log(error);
          });
    }
  },
  mounted() {
    this.getDataCustomerCategory();
    if (this.id) {
      this.getData();
    }
  },
  watch: {
    id(v) {
      if (v) {
        this.getData();
      } else {
        Object.assign(this.$data, this.initialState());
      }
    }
  }
}
</script>